import { Link, useNavigate } from "react-router-dom";
import { useCustomerFetch, Card, SectionLabel, StatusBadge, EmptyState, requestStatusMeta } from "../../components/customer-app/ui";
import { ChevronLeft, Archive, ChevronRight, Sun, Zap, Lightbulb, BatteryCharging, HelpCircle } from "lucide-react";

const CATEGORY_META = {
  epc: { label: "Rooftop Installation", icon: Sun },
  ev_charger: { label: "EV Charger", icon: Zap },
  street_light: { label: "Street Light", icon: Lightbulb },
  battery_storage: { label: "Battery Storage", icon: BatteryCharging },
  product_enquiry: { label: "Product Enquiry", icon: HelpCircle },
};

function RequestRow({ r }) {
  const meta = requestStatusMeta(r);
  const cat = CATEGORY_META[r.category] || CATEGORY_META.epc;
  const body = (
    <Card className="p-3.5 flex items-center gap-3" data-testid={`past-order-${r.req_id}`}>
      <div className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center flex-shrink-0">
        <cat.icon className="w-4.5 h-4.5 text-slate-500" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold text-slate-800 truncate">{r.name}</div>
        <div className="text-[11px] text-slate-400 font-mono mt-0.5 flex items-center gap-1.5">
          <span>{r.code}</span><span>·</span><span>{cat.label}</span>
          <span>·</span><span>{new Date(r.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</span>
        </div>
      </div>
      <div className="flex items-center gap-1.5 flex-shrink-0">
        <StatusBadge tone={meta.tone}>{meta.label}</StatusBadge>
        {r.link && <ChevronRight className="w-4 h-4 text-slate-300" />}
      </div>
    </Card>
  );
  return r.link ? <Link to={r.link} data-testid={`past-order-link-${r.req_id}`}>{body}</Link> : body;
}

export default function CustomerPastOrders() {
  const nav = useNavigate();
  const { data: requests, loading } = useCustomerFetch("/customer-app/requests");

  return (
    <div className="space-y-3 pb-4" data-testid="customer-past-orders">
      <button onClick={() => nav(-1)} data-testid="past-orders-back-btn" className="inline-flex items-center gap-1 text-xs font-bold text-slate-500 mb-1">
        <ChevronLeft className="w-3.5 h-3.5" /> Back
      </button>
      <SectionLabel>Past Orders</SectionLabel>
      <div className="text-xs text-slate-400 -mt-1">
        Every rooftop installation & product-enquiry request on your account — from any source.
      </div>

      {loading && <div className="h-20 rounded-2xl bg-slate-100 animate-pulse" />}

      {!loading && requests?.length === 0 && (
        <EmptyState icon={Archive} title="No requests yet" subtitle="Once you enquire about an installation or product, it'll show up here." />
      )}

      {!loading && requests?.length > 0 && (
        <div className="space-y-2">
          {requests.map((r) => <RequestRow key={`${r.kind}-${r.req_id}`} r={r} />)}
        </div>
      )}
    </div>
  );
}
